<template>
  <v-navigation-drawer dark absolute expand-on-hover permanent right>
    <v-list dense>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Documents</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-for="item in items" :key="item.id" @click="loadVersion(item.id)">
        <v-list-item-icon>
          <v-icon>mdi-poll</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.doc.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "ResultRollOutBar",
  data() {
    return {
      allowAdmin: true,
    };
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
  },
  computed: {

  },
  methods: {
    loadVersion(val) {
      this.$emit("loadVersion", val);
    },
  },
};
</script>
